import { useField } from 'formik';

import { ProductMessage } from '../../../../types/ProductMessage';
import { Text } from '../../../cdl/Text/Text';
import { FormikProductSelect } from '../../form-elements/formik/FormikProductSelect';
import { FormikProductSelectWithSuggestedProduct } from '../../form-elements/formik/FormikProductSelectWithSuggestedProduct';
import { translate } from '../../helpers/translate.helper';
import { useProductStringFormat } from '../../hooks/useProductStringFormat';
import { useVesselDefaultProducts } from '../../hooks/useVesselDefaultProducts';
import { Box } from '../../ui/Box';

interface ProductNameDisplayProps {
    name: string;
    vesselIdName: string;
    onSelect: (product: ProductMessage) => void;
    editable: boolean;
}

export const ProductNameDisplay = (props: ProductNameDisplayProps) => {
    const [itemField] = useField(props.name);
    const [vesselIdField] = useField(props.vesselIdName);

    const item = itemField.value;
    const vesselId = vesselIdField.value;
    const sourceProductName = item.sourceValues?.product?.name;
    const hasUnresolvedSourceProduct = !!sourceProductName && !item.productId && !item.deleted;

    const formatProductString = useProductStringFormat();

    const defaultProducts = useVesselDefaultProducts({
        vesselId,
        enabled: props.editable,
    });

    if (!props.editable) {
        return (
            <Box display="flex" flexDirection="column" gap={8}>
                <Text variant="small">
                    {!item.isTranslationMissing()
                        ? formatProductString(item.product)
                        : translate('global.translationmissing')}
                </Text>

                {item.baseProduct && item.baseProductId !== item.productId ? (
                    <Text variant="subtitle2" color="foreground.subtle">
                        {translate('offer.edit.lubes.requestedProduct', {
                            product: formatProductString(item.baseProduct),
                        })}
                    </Text>
                ) : null}
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" gap={8}>
            {hasUnresolvedSourceProduct ? (
                <FormikProductSelectWithSuggestedProduct
                    name={`${props.name}.productId`}
                    disabled={item.deleted}
                    onSelect={props.onSelect}
                    defaultProducts={defaultProducts}
                    vesselId={vesselId}
                    placeholder={sourceProductName}
                    forceNegative
                    suggestedProductName={sourceProductName}
                />
            ) : (
                <FormikProductSelect
                    name={`${props.name}.productId`}
                    disabled={item.deleted}
                    onSelect={props.onSelect}
                    defaultProducts={defaultProducts}
                    vesselId={vesselId}
                />
            )}

            {item.baseProduct && item.baseProductId !== item.productId ? (
                <Text
                    marginLeft="12px"
                    variant="subtitle2"
                    color={item.deleted ? 'foreground.disabled' : 'foreground.subtle'}
                >
                    {translate('offer.edit.lubes.requestedProduct', {
                        product: formatProductString(item.baseProduct),
                    })}
                </Text>
            ) : null}
        </Box>
    );
};
